module.exports = __webpack_public_path__ + "img/ltu.7605a4af.svg";